
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return import.meta.resolve($parcel$distDir + url);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0939"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0939"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
'use strict';
const $276a0e9908831999$export$ce0e5beb5efeb79 = Object.freeze({
    LIGHT: 'light',
    DARK: 'dark'
});
function $276a0e9908831999$export$a1547a14ea8d5a15(value) {
    return value === $276a0e9908831999$export$ce0e5beb5efeb79.LIGHT || value === $276a0e9908831999$export$ce0e5beb5efeb79.DARK;
}
function $276a0e9908831999$export$c412900fa5efae76(theme) {
    return theme === $276a0e9908831999$export$ce0e5beb5efeb79.DARK ? $276a0e9908831999$export$ce0e5beb5efeb79.LIGHT : $276a0e9908831999$export$ce0e5beb5efeb79.DARK;
} /**
 * @typedef {THEMES[keyof typeof THEMES]} Theme
 * */ 


'use strict';
function $95ac4d964baa5f8c$export$822342adebd1252b(storage, system, ui) {
    let current_theme = '';
    /**
     *
     */ const start = ()=>{
        current_theme = storage.load() || system.current();
        ui.apply(current_theme, false);
        ui.update_toggle(current_theme);
        system.on_change((theme)=>{
            if (!storage.load()) {
                current_theme = theme;
                ui.apply(theme, true);
                ui.update_toggle(theme);
            }
        });
    };
    /**
     *
     */ const toggle = ()=>{
        current_theme = (0, $276a0e9908831999$export$c412900fa5efae76)(current_theme);
        storage.save(current_theme);
        ui.apply(current_theme, true);
        ui.update_toggle(current_theme);
    };
    return {
        start: start,
        toggle: toggle
    };
} /**
 * @typedef  {object} ThemeService
 * @property {()=>void} start
 * @property {()=>void} toggle
 * */ 


'use strict';
class $ce8b88ffb7627d74$export$c25a46012a4319a1 extends Error {
    /**
     *
     */ constructor(){
        super('Failed to save theme to localstorage');
    }
}



'use strict';
function $3d0dc237c3e74aa0$export$796a3c4eda06b041(storage_key) {
    /**
     * @returns {Theme | null}
     */ const load = ()=>{
        try {
            const value = localStorage.getItem(storage_key);
            return (0, $276a0e9908831999$export$a1547a14ea8d5a15)(value) ? value : null;
        } catch  {
            return null;
        }
    };
    /**
     * @param {Theme} theme
     * */ const save = (theme)=>{
        try {
            localStorage.setItem(storage_key, theme);
        } catch  {
            new (0, $ce8b88ffb7627d74$export$c25a46012a4319a1)();
        }
    };
    return {
        load: load,
        save: save
    };
}



'use strict';
function $79dc158e90b1a798$export$68dd5521f6e5c25b() {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    /**
     * @type {Current}
     * */ const current = ()=>{
        return media.matches ? (0, $276a0e9908831999$export$ce0e5beb5efeb79).DARK : (0, $276a0e9908831999$export$ce0e5beb5efeb79).LIGHT;
    };
    /**
     * @type {OnChange}
     * */ const on_change = (handler)=>{
        media.addEventListener('change', (event)=>{
            handler(event.matches ? (0, $276a0e9908831999$export$ce0e5beb5efeb79).DARK : (0, $276a0e9908831999$export$ce0e5beb5efeb79).LIGHT);
        });
    };
    return {
        current: current,
        on_change: on_change
    };
} /**
 * @typedef {import("./theme").Theme} Theme
 * @typedef {object} SystemMedia
 * @property {Current} current
 * @property {OnChange} on_change
 * */  /**
 * @callback ThemeChangeHandler
 * @param {Theme} theme
 * @returns {void}
 * */  /**
 * @callback Current
 * @returns {Theme}
 * */  /**
 * @callback OnChange
 * @param {ThemeChangeHandler} handler
 * @returns {void}
 * */ 



'use strict';
function $713114a7b254fb37$export$4a1163a0993c6038() {
    /**
     * @type {HTMLElement}
     * */ const root = document.documentElement;
    /**
     * @type {Apply}
     * */ const apply = (theme, with_transition)=>{
        if (with_transition) root.classList.add('theme-transition');
        root.setAttribute('data-theme', theme);
        if (with_transition) setTimeout(()=>root.classList.remove('theme-transition'), 300);
    };
    /**
     * @type {UpdateToggle}
     * */ const update_toggle = (theme)=>{
        const button = document.getElementById('theme-toggle');
        if (!button) return;
        const next = (0, $276a0e9908831999$export$c412900fa5efae76)(theme);
        button.setAttribute('aria-label', `Switch to ${next} theme`);
        button.setAttribute('aria-pressed', String(theme === (0, $276a0e9908831999$export$ce0e5beb5efeb79).DARK));
    };
    return {
        apply: apply,
        update_toggle: update_toggle
    };
} /**
 * @typedef {import("./theme").Theme} Theme
 * @typedef {object} ThemeUi
 * @property {Apply} apply
 * @property {UpdateToggle} update_toggle
 * */  /**
 * @callback Apply
 * @param {Theme} theme
 * @param {boolean} with_transition
 * @returns {void}
 * */  /**
 * @callback UpdateToggle
 * @param {Theme} theme
 * @returns {void}
 * */ 


/**
 * @param {import('./service').ThemeService}  service
 * */ function $73de33c38bfa5c3b$export$ff6afb37bf32e20(service) {
    const button = document.getElementById('theme-toggle');
    if (!button) return;
    button.addEventListener('click', ()=>{
        service.toggle();
    });
}




/**
 * @typedef {"json"} InputType
 * @typedef {"golang" | "jsdoc" | "typescript" | "zod"} Format
 */ const $dd3b75789f9c576d$export$83b3338595758b4b = {
    golang: 'golang',
    jsdoc: 'jsdoc',
    typescript: 'typescript',
    zod: 'zod'
};
const $dd3b75789f9c576d$export$d1576927a1219cd4 = {
    json: 'json'
};


class $c9fb62759d2ea27d$export$827b38dced4a2f9c extends Error {
    /**
     *
     * @param format
     */ constructor(format){
        const formats = Object.keys((0, $dd3b75789f9c576d$export$83b3338595758b4b)).join(', ');
        super(`Expected one of: ${formats}, received: '${format}'`);
    }
}
class $c9fb62759d2ea27d$export$a999c3277f94f674 extends Error {
    /**
     *
     * @param input_type
     */ constructor(input_type){
        const types = Object.keys((0, $dd3b75789f9c576d$export$d1576927a1219cd4)).join('|');
        super(`Expected one of: ${types}, received: '${input_type}'`);
    }
}
class $c9fb62759d2ea27d$export$e5ac93839bcdef4d extends Error {
    /**
     *
     * @param max_length
     */ constructor(max_length){
        super(`Input value cannot exceed ${max_length}`);
    }
}
class $c9fb62759d2ea27d$export$88a13612578a6410 extends Error {
    /**
     *
     * @param format
     * @param cause
     */ constructor(format, cause){
        super(`Invalid ${format} syntax`, {
            cause: cause
        });
    }
}


'use strict';
function $6b47dc4a14c725d2$export$7c53127ec179bb42(codegen_handler) {
    /**
     * @type {Execute}
     * */ const execute = async (request)=>{
        try {
            const response = await codegen_handler.send({
                input_type: request.input_type(),
                input: request.input(),
                format: request.format()
            });
            if (response.status === 'error') return [
                {
                    code: '',
                    format: -1
                },
                new $6b47dc4a14c725d2$var$CodegenError(response.message)
            ];
            return [
                response.data,
                null
            ];
        } catch (error) {
            const exceptions = [
                (0, $c9fb62759d2ea27d$export$a999c3277f94f674),
                (0, $c9fb62759d2ea27d$export$827b38dced4a2f9c),
                (0, $c9fb62759d2ea27d$export$e5ac93839bcdef4d),
                (0, $c9fb62759d2ea27d$export$88a13612578a6410)
            ];
            if (exceptions.some((exception)=>error instanceof exception)) return [
                {
                    code: '',
                    format: -1
                },
                error
            ];
            return [
                {
                    code: '',
                    format: -1
                },
                new $6b47dc4a14c725d2$var$CodegenError('Unhandled exception', error)
            ];
        }
    };
    return {
        execute: execute
    };
}
/**
 * @typedef {object} CodegenService
 * @property {Execute} execute
 * */ /**
 * @callback Execute
 * @param {import("./request").CodegenRequest} request
 * @returns {Promise<[import("./api").CodegenResponse, Error]>}
 * @throws {CodegenError}
 * */ /**
 *
 */ class $6b47dc4a14c725d2$var$CodegenError extends Error {
    /**
     *
     * @param msg
     * @param cause
     */ constructor(msg, cause){
        super(msg, {
            cause: cause
        });
    }
}




'use strict';
const $1d9514c02e30a142$export$c2a8ada50e3bcc2a = {
    /**
     * @param {HTMLFormElement} form
     * @returns {CodegenRequest}
     * */ create (form) {
        const formValues = new FormData(form);
        const get_input_type = ()=>{
            const input_type = formValues.get('input_type').trim();
            if (!Object.keys((0, $dd3b75789f9c576d$export$d1576927a1219cd4)).includes(input_type)) throw new (0, $c9fb62759d2ea27d$export$a999c3277f94f674)(input_type);
            return input_type;
        };
        const get_input = ()=>{
            const input = formValues.get('structure-input').trim();
            if (input.length > 10000) throw new (0, $c9fb62759d2ea27d$export$e5ac93839bcdef4d)(10000);
            try {
                JSON.parse(input);
            } catch (error) {
                throw new (0, $c9fb62759d2ea27d$export$88a13612578a6410)('json', error);
            }
            return input;
        };
        const get_format = ()=>{
            const format = formValues.get('format').trim();
            if (!Object.keys((0, $dd3b75789f9c576d$export$83b3338595758b4b)).includes(format)) throw new (0, $c9fb62759d2ea27d$export$827b38dced4a2f9c)(format);
            return format;
        };
        return {
            input_type: get_input_type,
            input: get_input,
            format: get_format
        };
    }
}; /**
 * @typedef {object} CodegenRequest
 * @property {InputTypeGetter} input_type
 * @property {InputGetter} input
 * @property {FormatGetter} format
 * */  /**
 * @callback InputTypeGetter
 * @throws {InvalidInputTypeException}
 * @returns {import("./domain").InputType}
 * */  /**
 * @callback InputGetter
 * @returns {string}
 * */  /**
 * @callback FormatGetter
 * @throws {InvalidFormatException}
 * @returns {import("./domain").Format}
 * */ 




/**
 * @param {import("../codegen/codegen").CodegenService} codegen_service
 * @param {typeof import("../codegen/request").codegen_request_factory} request_factory
 * @param {import("../notification/notification").NotificationService} notification_service
 * @returns {CodegenDriver}
 * */ function $49f573893d7ba307$export$298688e47c972b7b(codegen_service, request_factory, notification_service) {
    /**
     * @type {Start}
     * */ const start = (form, button)=>{
        form.addEventListener('submit', async (event)=>{
            try {
                event.preventDefault();
                button.setAttribute('disabled', 'true');
                const [data, error] = await codegen_service.execute(request_factory.create(event.target));
                if (error) {
                    notification_service.show_error(error.message || 'Failed to generate code');
                    button.removeAttribute('disabled');
                    return;
                }
                const output_container = document.getElementById('output-code');
                output_container.innerText = data.code;
                notification_service.show_success('Code generated successfully!');
                button.removeAttribute('disabled');
            } catch (error) {
                notification_service.show_error(error.message);
            }
        });
    };
    return {
        start: start
    };
} /**
 * @typedef {object} CodegenDriver
 * @property {Start} start
 * */  /**
 * @callback Start
 * @param {HTMLFormElement} form
 * @param {HTMLButtonElement} button
 * @returns { void }
 * */ 


'use strict';
function $4405b3f923f19046$export$cf62a3466062916d(clipboard, notifications) {
    /**
     * @type {Start}
     * */ const start = (button)=>{
        button.addEventListener('click', async ()=>{
            const output = document.getElementById('output-code');
            const code = output.innerText;
            clipboard.save(code);
            notifications.show_success('Saved to clipboard!');
        });
    };
    return {
        start: start
    };
} /**
 * @callback Start
 * @param {HTMLButtonElement} button
 * */  /**
 * @typedef Driver
 * @property {Start} start
 * */ 


/**
 * @param {ClipboardClient} client
 * @returns {ClipboardService}
 * */ function $2e1600e00eb14e1b$export$984d4661e8ba565f(client) {
    /**
     * @type {Save}
     * */ const save = (text)=>{
        // TODO:indicate success/failure of the copy to clipboard action in the UI
        return client.writeText(text);
    };
    return {
        save: save
    };
} /**
 * @typedef {object} ClipboardClient
 * @property {(string)=>Promise<void>} writeText
 * */  /**
 * @callback Save
 * @param {string} text
 * @returns {Promise<void>}
 * */  /**
 * @typedef ClipboardService
 * @property {Save} save
 * */ 


'use strict';
function $1129469dddf70daf$export$d191076365900f13() {
    const config = {
        type: '',
        msg: ''
    };
    return {
        with_type (type) {
            config.type = type;
            return this;
        },
        with_message (msg) {
            config.msg = msg;
            return this;
        },
        build () {
            if (config.type !== 'error' && config.type !== 'success') return [
                $1129469dddf70daf$var$null_notification,
                new Error(`Expected type to be "success" or "error", received: ${config.type}`)
            ];
            if (config.msg === '') return [
                $1129469dddf70daf$var$null_notification,
                new Error(`Notification cannot have an empty message`)
            ];
            return [
                $1129469dddf70daf$var$create_notification(config),
                null
            ];
        }
    };
}
/**
 * @param {{msg: string; type: string}} config
 * */ function $1129469dddf70daf$var$create_notification(config) {
    let is_active = true;
    const toast = document.createElement('div');
    toast.className = `toast toast--${config.type}`;
    toast.setAttribute('role', 'alert');
    const icon = config.type === 'success' ? $1129469dddf70daf$var$create_success_icon() : $1129469dddf70daf$var$create_error_icon();
    toast.innerHTML = `
            ${icon}
            <span class="toast__message">${config.msg}</span>
            <button class="toast__close" aria-label="Close notification">
                ${$1129469dddf70daf$var$create_close_icon()}
            </button>
        `;
    const close_button = toast.querySelector('.toast__close');
    const handle_close = ()=>{
        if (!is_active) {
            console.warn("Notification is already closed!: '%s'", config.msg);
            return;
        }
        toast.classList.remove('toast--visible');
        toast.classList.add('toast--removing');
        toast.addEventListener('animationend', ()=>{
            toast.remove();
            is_active = false;
        }, {
            once: true
        });
    };
    if (close_button) close_button.addEventListener('click', ()=>{
        close_button.setAttribute('disabled', 'true');
        handle_close();
    });
    return {
        html () {
            return toast;
        },
        value () {
            return toast.innerHTML;
        },
        active () {
            return is_active;
        },
        close: handle_close
    };
}
/**
 * @returns {string}
 */ const $1129469dddf70daf$var$create_success_icon = ()=>`
        <svg class="toast__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
    `;
/**
 * @returns {string}
 */ const $1129469dddf70daf$var$create_error_icon = ()=>`
        <svg class="toast__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
    `;
/**
 * @returns {string}
 */ const $1129469dddf70daf$var$create_close_icon = ()=>`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
    `;
/**
 * @type {Notification}
 * */ const $1129469dddf70daf$var$null_notification = {
    html: ()=>document.createElement('div'),
    value: ()=>'',
    is_active: ()=>false,
    close () {}
}; /**
 * @typedef {object} Notification
 * @property {()=>HTMLElement} html
 * @property {()=>string} value
 * @property {()=>boolean} active
 * @property {()=>void} close
 * */  /**
 * @typedef {object} NotificationBuilder
 * @property {(type: "error" | "success")=>NotificationBuilder} with_type
 * @property {(msg: string)=>NotificationBuilder} with_message
 * @property {()=>[ Notification, Error ]} build
 * */ 


'use strict';
function $7fef65acc7464686$export$db017b47ad6f381d(notification_container) {
    /** @type {NotificationService["show_success"]} */ const show_success = (message)=>{
        const builder = (0, $1129469dddf70daf$export$d191076365900f13)();
        const [notification, error] = builder.with_type('success').with_message(message).build();
        if (error) {
            show_error(`Error creating notification: ${error.message}`);
            return;
        }
        notification_container.add(notification);
        setTimeout(()=>{
            notification_container.remove(notification);
        }, 10000);
    };
    /** @type {NotificationService["show_error"]} */ const show_error = (message)=>{
        const builder = (0, $1129469dddf70daf$export$d191076365900f13)();
        const [notification, error] = builder.with_type('error').with_message(message).build();
        if (error) {
            show_error(`Error creating notification: ${error.message}`);
            return;
        }
        notification_container.add(notification);
        setTimeout(()=>{
            notification_container.remove(notification);
        }, 10000);
    };
    return {
        show_success: show_success,
        show_error: show_error,
        dismiss_all: notification_container.clear
    };
} /**
 * @typedef {object} NotificationService
 * @property {(msg: string)=>void} show_success
 * @property {(msg: string)=>void} show_error
 * @property {()=>void} dismiss_all
 */ 


'use strict';
const $72c6dc9f38f618f7$var$CONTAINER_ID = 'notification-container';
function $72c6dc9f38f618f7$export$71d95e9ca5ea1282() {
    const container = $72c6dc9f38f618f7$var$get_container($72c6dc9f38f618f7$var$CONTAINER_ID);
    /**
     * @type {Set<import("./notification").Notification>}
     * */ const notifications = new Set();
    // TODO: Display a "clear" button when 3 or more notifications are in the container
    return Object.freeze({
        add (notification) {
            const toast = notification.html();
            container.appendChild(toast);
            // Trigger reflow to ensure animation plays
            toast.offsetHeight;
            toast.classList.add('toast--visible');
            notifications.add(notification);
        },
        remove (notification) {
            if (notifications.has(notification)) {
                notification.close();
                notifications.delete(notification);
            }
        },
        clear () {
            for (const notification of notifications){
                notification.close();
                notifications.delete(notification);
            }
        }
    });
}
/**
 * @param id
 * @returns {HTMLElement}
 */ const $72c6dc9f38f618f7$var$get_container = (id)=>{
    let container = document.getElementById(id);
    if (!container) {
        container = document.createElement('div');
        container.id = $72c6dc9f38f618f7$var$CONTAINER_ID;
        container.className = 'toast-container';
        container.setAttribute('aria-live', 'polite');
        container.setAttribute('aria-atomic', 'false');
        document.body.appendChild(container);
    }
    return container;
}; /**
 * @typedef {object} NotificationContainer
 * @property {(notification: import("./notification").Notification)=>void} add
 * @property {(notification: import("./notification").Notification)=>void} remove
 * @property {()=>void} clear
 * */ 




'use strict';
var $be55ea0812813c86$exports = {};
$be55ea0812813c86$exports = $parcel$resolve("worker.41b28b9f.js");


function $2bea1b4cfe11ed0f$export$2b32509f061e853() {
    const worker = new Worker(new URL($be55ea0812813c86$exports), {
        type: 'module'
    });
    const pending_requests = new Map();
    worker.addEventListener('message', (event)=>{
        const response = JSON.parse(event.data);
        const entry = pending_requests.get(response.id);
        if (!entry) return;
        if (response.error) entry.reject(response.error);
        else entry.resolve(response);
    });
    worker.addEventListener('error', (error)=>{
        for (const { reject: reject } of pending_requests.values())reject(error);
        pending_requests.clear();
    });
    return {
        async send (request, timeout_ms = 5000) {
            return new Promise((resolve, reject)=>{
                if (pending_requests.has(request.id)) throw new Error(`Duplicate request id ${request.id}`);
                const timer_id = setTimeout(()=>{
                    pending_requests.delete(request.id);
                    reject(new Error('RPC timeout'));
                }, timeout_ms);
                pending_requests.set(request.id, {
                    resolve: (value)=>{
                        clearTimeout(timer_id);
                        pending_requests.delete(request.id);
                        resolve(value);
                    },
                    reject: (error)=>{
                        clearTimeout(timer_id);
                        pending_requests.delete(request.id);
                        reject(error);
                    }
                });
                worker.postMessage(request);
            });
        },
        close () {
            for (const { reject: reject } of pending_requests.values())reject(new Error('Worker terminated.'));
            pending_requests.clear();
            worker.terminate();
        }
    };
} /**
 * @typedef {object} RpcClient
 * @property {SendRPCCommand} send
 * @property {()=>void} close
 * */  /**
 * @callback SendRPCCommand
 * @param {import("../libs/jsonrpc").JSONRPCRequest<unknown>} request
 * @returns {Promise<import("../libs/jsonrpc").JSONRPCResponse<unknown>>}
 * */ 


'use strict';
let $38b6621d7d721506$var$id = 1;
function $38b6621d7d721506$export$5bc64a5e6140bad4(method, body) {
    return {
        method: method,
        jsonrpc: '2.0',
        params: body,
        id: $38b6621d7d721506$var$id++
    };
}
function $38b6621d7d721506$export$fe2df03055dfd46(response) {
    if (!('jsonrpc' in response)) throw new Error('Missing required param "jsonrpc"');
    if (typeof response.jsonrpc !== 'string') throw new Error(`Invalid jsonrpc type. Expected string, received ${typeof response.jsonrpc}`);
    if (response.jsonrpc !== '2.0') throw new Error(`Invalid rpc version. Expected 2.0, received ${response.jsonrpc}`);
    if (typeof response.id !== 'number') throw new Error(`Invalid id type. Expected number, received ${typeof response.jsonrpc}`);
    if (response.error) {
        if (typeof response.error.code !== 'number') throw new Error(`Invalid error code type. Expected number, received ${typeof response.jsonrpc}`);
    }
} /**
 * @template T
 * @typedef {object} JSONRPCRequest
 * @property {"2.0"} jsonrpc
 * @property {string} method
 * @property {T} params
 * @property {number} id
 * */  /**
 * @template T
 * @typedef {object} JSONRPCResponse
 * @property {"2.0"} jsonrpc
 * @property {T}  [result]
 * @property {number} [id]
 * @property {JSONRPCError} [error]
 * */  /**
 * @typedef {object} JSONRPCError
 * @property {number} code
 * @property {string} [message]
 * @property {object} [data]
 * */ 



'use strict';
function $b2db6037a212ec86$export$c7fd7ec33ea4fd97(response) {
    (0, $38b6621d7d721506$export$fe2df03055dfd46)(response);
    return {
        code: response.result.code,
        format: response.result.format
    };
}


'use strict';
function $bcbff1d7d964369b$export$c22f43210d32520d(client) {
    return {
        /**
         *
         * @param command
         */ async send (command) {
            try {
                const request = (0, $38b6621d7d721506$export$5bc64a5e6140bad4)('codegen', command);
                const response = await client.send(request);
                return {
                    status: 'ok',
                    data: (0, $b2db6037a212ec86$export$c7fd7ec33ea4fd97)(response)
                };
            } catch (error) {
                return {
                    status: 'error',
                    err: new Error('Error while making request', {
                        cause: error
                    })
                };
            }
        }
    };
}


'use strict';
document.addEventListener('DOMContentLoaded', ()=>{
    const theme_driver = (0, $95ac4d964baa5f8c$export$822342adebd1252b)(// TODO: refactor to fit the driver convention
    (0, $3d0dc237c3e74aa0$export$796a3c4eda06b041)('typedef-theme-preference'), (0, $79dc158e90b1a798$export$68dd5521f6e5c25b)(), (0, $713114a7b254fb37$export$4a1163a0993c6038)());
    const notification_service = (0, $7fef65acc7464686$export$db017b47ad6f381d)((0, $72c6dc9f38f618f7$export$71d95e9ca5ea1282)());
    const rpc_client = (0, $2bea1b4cfe11ed0f$export$2b32509f061e853)();
    const codegen_handler = (0, $bcbff1d7d964369b$export$c22f43210d32520d)(rpc_client);
    const codegen_driver = (0, $49f573893d7ba307$export$298688e47c972b7b)((0, $6b47dc4a14c725d2$export$7c53127ec179bb42)(codegen_handler), (0, $1d9514c02e30a142$export$c2a8ada50e3bcc2a), notification_service);
    const clipboard_driver = (0, $4405b3f923f19046$export$cf62a3466062916d)((0, $2e1600e00eb14e1b$export$984d4661e8ba565f)(navigator.clipboard), notification_service);
    (0, $73de33c38bfa5c3b$export$ff6afb37bf32e20)(theme_driver);
    theme_driver.start();
    clipboard_driver.start(document.getElementById('copy-btn'));
    codegen_driver.start(document.querySelector('form'), document.getElementById('transform-btn'));
});


//# sourceMappingURL=web.901e9d76.js.map
